/* eslint-disable @typescript-eslint/no-explicit-any */
import { IGif, INiche, IUser, IUserLink, IUserSettings } from "services/types";

export interface ICurrentUser {
  creationtime: number;
  description: string;
  followers: number;
  following: number;
  gifs: number;
  links?: IUserLink[];
  name: string;
  poster: string;
  preferences?: string[];
  preview: string;
  profileImageUrl: string;
  profileUrl: string;
  publishedCollections: number;
  publishedGifs: number;
  roles?: string[];
  settings: IUserSettings;
  socialUrl1?: string; // pornhub
  socialUrl2?: string; // twitter
  socialUrl3?: string; // instagram
  socialUrl4?: string; // manyvids
  socialUrl5?: string; // reddit
  socialUrl6?: string; // onlyfans
  socialUrl7?: string; // patreon
  socialUrl8?: string; // xhamster
  socialUrl9?: string; // chaturbate
  socialUrl10?: string; // myfreecams
  socialUrl11?: string; // fansly
  socialUrl12?: string; // camsoda
  socialUrl13?: string; // fancentro
  socialUrl14?: string; // youtube
  socialUrl15?: string; // facebook
  socialUrl16?: string; // discord
  status: string;
  subscription: number;
  thumbnail:string;
  url: string;
  username: string;
  verified: boolean;
  views: number;
  email: string;
}

export interface IUserState {
  currentUser: ICurrentUser;
  currentUserContent: IGif[] | any [] | any;
  loadingUserContent: boolean;
  currentUserContentError: Error | null;
  currentUserFollowers: Array<IUser> | [];
  currentUserFollowersError: Error | null;
  currentUserFollows: {
    count?: number;
    cursor?: string;
    follows: Array<IUser> | [];
    status?: string;
    totalCount?: number;
    error: Error | null;
  };
  loadingUser: boolean;
  loadingUserFollows: boolean;
  userLoginError: Error | null;
  followUserError: Error | null;
  likedGifs: string[];
  loadingLikedGifs: boolean;
  updatingUserSettings: boolean;

  myNiches: INiche[];
  loadingMyNiches: boolean;
  myNichesError: Error | null;
}

const defaultState = {
  currentUser: {} as ICurrentUser,
  currentUserContent: [],
  currentUserContentError: null,
  loadingUserContent: false,
  currentUserFollowers: [],
  currentUserFollowersError: null,
  currentUserFollows: {
    follows: [],
    error: null,
  },
  loadingUser: false,
  loadingUserFollows: false,
  userLoginError: null,
  followUserError: null,
  likedGifs: [],
  loadingLikedGifs: false,
  updatingUserSettings: false,

  myNiches: [],
  loadingMyNiches: false,
  myNichesError: null,
};

export const getDefaultUserState = () => defaultState;
